/**
 * prefetch.js — prefetch de chunks lazy en hover/focus para que la nav sea instant.
 *
 * Uso:
 *   import { prefetchRoute } from "../lib/prefetch";
 *   <Link to="/tareas" onMouseEnter={() => prefetchRoute("tareas")} />
 */

const PREFETCHERS = {
  dashboard:     () => import("../pages/Dashboard.jsx"),
  tareas:        () => import("../pages/Tareas.jsx"),
  tareaDetalle:  () => import("../pages/TareaDetalle.jsx"),
  calendario:    () => import("../pages/Calendario.jsx"),
  galeria:       () => import("../pages/Galeria.jsx"),
  reportes:      () => import("../pages/Reportes.jsx"),
  pedidos:       () => import("../pages/Pedidos.jsx"),
  facturas:      () => import("../pages/Facturas.jsx"),
  equipo:        () => import("../pages/Equipo.jsx"),
  brand:         () => import("../pages/Brand.jsx"),
  documentos:    () => import("../pages/Documentos.jsx"),
  favoritos:     () => import("../pages/Favoritos.jsx"),
  configuracion: () => import("../pages/Configuracion.jsx"),
  // v8.3.10 · rutas nuevas que faltaban
  campanas:      () => import("../pages/Campanas.jsx"),
  planes:        () => import("../pages/Planes.jsx"),
  "feed-preview":() => import("../pages/FeedPreview.jsx"),
  chat:          () => import("../pages/Chat.jsx"),
  coberturas:    () => import("../pages/Coberturas.jsx"),
};

const triggered = new Set();
export function prefetchRoute(key) {
  if (triggered.has(key)) return;
  triggered.add(key);
  PREFETCHERS[key]?.().catch(() => triggered.delete(key));
}

// Helper para hover handler
export function withPrefetch(key) {
  return { onMouseEnter: () => prefetchRoute(key), onFocus: () => prefetchRoute(key) };
}
